import { createSelector } from 'redux-orm';

import orm from '../orm';
import { selectPointSystemForCurrentBoard } from './point-systems';

export const selectContentViewPlanForCurrentBoardByYearMonth = createSelector(
  orm,
  (_, year) => year,
  (_, __, month) => month,
  (state) => selectPointSystemForCurrentBoard(state),
  ({ ContentViewPlan }, year, month, pointSystem) => {
    if (!pointSystem) {
      return null;
    }

    const model = ContentViewPlan.all()
      .filter({
        pointSistemId: pointSystem.id,
        year,
        month,
      })
      .first();

    return model ? model.ref : null;
  },
);

export const selectContentViewPlansForCurrentBoardPointSystem = createSelector(
  orm,
  (state) => selectPointSystemForCurrentBoard(state),
  ({ ContentViewPlan }, pointSystem) => {
    if (!pointSystem) {
      return [];
    }

    return ContentViewPlan.all()
      .filter({
        pointSistemId: pointSystem.id,
      })
      .toRefArray();
  },
);

export const makeSelectContentViewPlansByPointSystemId = () =>
  createSelector(
    orm,
    (_, pointSystemId) => pointSystemId,
    ({ ContentViewPlan }, pointSystemId) => {
      if (!pointSystemId) {
        return [];
      }

      return ContentViewPlan.all()
        .filter({
          pointSistemId: pointSystemId,
        })
        .toRefArray();
    },
  );

export default {
  selectContentViewPlanForCurrentBoardByYearMonth,
  selectContentViewPlansForCurrentBoardPointSystem,
  makeSelectContentViewPlansByPointSystemId,
};

